import Swal from "sweetalert2";
import functions from "../..";
import { PedidoSelectedFilters } from "@/interfaces/Pedidos";
import { Axios } from "axios";

// Usa tipos para el response
interface PedidoDetalleResponse {
  data: {
    factor: number;
    id: string;
    nomcli: string;
    rif: string;
    marca: string;
    fecha: string;
    fecenviado?: string;
    usuario: string;
    estado: string;
    origen: string;
    total_pedido: number | string;
    total_pedido_ext?: number | string;
    comentario?: string;
    desc_indexados_marca?: string;
    pedren: Array<{
      factor: number;
      dm?: string;
      desprod: string;
      cantidad: number;
      dn?: string;
      desc_indexados?: string;
      neto: number;
      precio: number;
    }>;
  };
}

function getIndexados(indexados?: string): string {
  if (!indexados) return `0.00`;
  try {
    const parsed = JSON.parse(indexados);
    if (!Array.isArray(parsed)) return "0.00";
    return parsed.map((item: any) =>
      `<span title="${item.description}" class="cursor-pointer">${parseFloat(item.amountWithoutPercent).toFixed(2)}</span>`
    ).join(' + ');
  } catch (e) {
    return "0.00";
  }
}

async function getDetallePedido(
  axios: Axios,
  apiRoute: string,
  searchParams: PedidoSelectedFilters | {}
): Promise<PedidoDetalleResponse | undefined> {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Authentication token not found');
    const headers = { Authorization: `Bearer ${token}` };
    const response = await axios.get(apiRoute + '/pedido/showOne', { headers, params: searchParams });
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

function aplicarTodosLosDescuentosCascada(
  neto: number,
  dm: number | string | undefined,
  dn: number | string | undefined,
  descIndexadosMarca?: string,
  descIndexadosItem?: string
): number {
  let result = neto;

  // 1. Descuento negociado por marca
  if (dm !== undefined && dm !== null && !isNaN(Number(dm))) {
    result = result * (1 - Number(dm) / 100);
  }

  // 2. Descuento negociado por producto
  if (dn !== undefined && dn !== null && !isNaN(Number(dn))) {
    result = result * (1 - Number(dn) / 100);
  }

  // 3. Descuentos indexados por marca (array JSON)
  if (descIndexadosMarca) {
    try {
      const descuentosMarca = JSON.parse(descIndexadosMarca);
      if (Array.isArray(descuentosMarca)) {
        descuentosMarca.forEach(d => {
          const percent = d.amountWithoutPercentOri !== undefined
            ? parseFloat(d.amountWithoutPercentOri)
            : (d.amountWithoutPercent !== undefined ? parseFloat(d.amountWithoutPercent) : 0);
          result = result * (1 - percent / 100);
        });
      }
    } catch(err){
      console.log("Error parsing desc_indexados_marca:", err);
      
    }
  }

  // 4. Descuentos indexados por producto (array JSON)
  if (descIndexadosItem) {
    try {
      const descuentosItem = JSON.parse(descIndexadosItem);
      if (Array.isArray(descuentosItem)) {
        descuentosItem.forEach(d => {
          const percent = d.amountWithoutPercentOri !== undefined
            ? parseFloat(d.amountWithoutPercentOri)
            : (d.amountWithoutPercent !== undefined ? parseFloat(d.amountWithoutPercent) : 0);
          result = result * (1 - percent / 100);
        });
      }
    } catch (err){
      console.log("Error parsing desc_indexados_item:", err);
      
    }
  }

  return result;
}



export default function openPedidoModal(id: string, axios: Axios, apiRoute: string) {
  let tabContainer: HTMLElement | null = null;

  Swal.fire({
    focusConfirm: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
      const searchParams = { id };
      getDetallePedido(axios, apiRoute, searchParams).then((response) => {
        Swal.close();
        if (!response) return;

        // Comentario si existe
        const commentRow = response.data.comentario
          ? `<div class="col-span-full bg-yellow-50 p-2 rounded text-xs mt-2">
              <span class="font-semibold text-slate-700">Comentario:</span>
              <span class="text-slate-700">${response.data.comentario}</span>
            </div>`
          : "";

          const totalBs = response.data.pedren.reduce((acc, item) => {
            const netoFinal = aplicarTodosLosDescuentosCascada(
              item.neto,
              item.dm,
              item.dn,
              item.desc_indexados
            );
            return acc + (netoFinal * item.cantidad);
          }, 0);

          const totalUsd = response.data.pedren.reduce((acc, item) => {
            const netoFinal = aplicarTodosLosDescuentosCascada(
              item.neto,
              item.dm,
              item.dn,
              item.desc_indexados
            );
            // Usa item.factor o el factor global de la cabecera, según tu estructura
            const factor = item.factor > 0 ? item.factor : (response.data.factor ?? 1);
            return acc + (factor ? (netoFinal / factor) * item.cantidad : 0);
          }, 0);

        // HTML del modal
        const htmlContent = `
            <div id="modal-content" class="font-sans min-w-[280px] max-w-full">
                <!-- Tabs Modernas -->
                <div class="flex justify-center mb-5">
                <nav class="space-x-2 relative flex rounded-full bg-slate-100/80 shadow-inner px-1 py-1 w-max mx-auto border border-slate-200">
                    <button
                    type="button"
                    class="w-[100px] tab-link tab-1 group flex items-center gap-2 px-5 py-2 text-sm font-semibold rounded-full transition-all duration-200
                        focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400
                        bg-white shadow text-blue-600 z-10 active-tab"
                    data-tab="#general-tab">
                    <i class='bx bx-info-circle text-base'></i>
                    <span>General</span>
                    </button>
                    <button
                    type="button"
                    class="w-[100px] tab-link tab-2 group flex items-center gap-2 px-5 py-2 text-sm font-semibold rounded-full transition-all duration-200
                        focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400
                        text-slate-600 hover:text-blue-600 hover:bg-white"
                    data-tab="#details-tab">
                    <i class='bx bx-list-ul text-base'></i>
                    <span>Detalles</span>
                    </button>
                </nav>
                </div>

                <!-- General Info -->
                <div class="tab-content" id="general-tab">
                <h2 class="mb-2 text-base font-bold text-center text-slate-700">Información General</h2>
                <div class="grid grid-cols-2 md:grid-cols-3 gap-2 text-xs sm:text-sm">
                    <div><span class="block font-semibold text-slate-600">ID:</span><span>${response.data.id}</span></div>
                    <div><span class="block font-semibold text-slate-600">Cliente:</span><span>${response.data.nomcli}</span></div>
                    <div><span class="block font-semibold text-slate-600">RIF:</span><span>${response.data.rif}</span></div>
                    <div><span class="block font-semibold text-slate-600">Marca:</span><span>${response.data.marca}</span></div>
                    <div><span class="block font-semibold text-slate-600">Fecha:</span><span>${response.data.fecha}</span></div>
                    <div><span class="block font-semibold text-slate-600">Renglones:</span><span>${response.data.pedren.length ?? 'N/A'}</span></div>
                    <div><span class="block font-semibold text-slate-600">Unidades:</span>
                    <span>
                        ${response.data.pedren.reduce((acc, item) => acc + item.cantidad, 0) ?? 'N/A'}
                    </span>
                    </div>
                    <div><span class="block font-semibold text-slate-600">Enviado:</span><span>${response.data.fecenviado ?? 'N/A'}</span></div>
                    <div><span class="block font-semibold text-slate-600">Usuario:</span><span>${response.data.usuario}</span></div>
                    <div><span class="block font-semibold text-slate-600">Estado:</span><span>${response.data.estado}</span></div>
                    <div><span class="block font-semibold text-slate-600">Origen:</span><span>${response.data.origen}</span></div>
                    <div><span class="block font-semibold text-slate-600">Total:</span>
                      <span>
                        ${functions.prices.formatCurrency(totalBs, 'es-VE', 'VES')}
                        <span class="text-slate-400">|</span>
                        ${functions.prices.formatCurrency(totalUsd, 'en-US', "USD")}
                      </span>
                    </div>
                    ${commentRow}
                </div>
                </div>

                <!-- Detalles -->
                <div class="tab-content hidden" id="details-tab">
                <h2 class="mb-2 text-base font-bold text-center text-slate-700">Renglones del pedido</h2>
                <div class="overflow-x-auto rounded border border-slate-200 max-h-72">
                    <table class="min-w-full text-xs sm:text-sm text-slate-700">
                    <thead class="bg-slate-100 sticky top-0 z-10">
                        <tr>
                        <th class="py-1 px-2 font-semibold w-[40%]">Descripción</th>
                        <th class="py-1 px-2 font-semibold w-[14%]">Cantidad</th>
                        <th class="py-1 px-2 font-semibold" title="Descuento negociado por marca">DN</th>
                        <th class="py-1 px-2 font-semibold" title="Descuento negociado por producto">DP</th>
                        <th class="py-1 px-2 font-semibold" title="Descuentos indexados">DI</th>
                        <th class="py-1 px-2 font-semibold">Neto</th>
                        <th class="py-1 px-2 font-semibold">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                      ${response.data.pedren.map((item, idx) => {
                        // Aplica todos los descuentos en cascada
                        const netoFinal = aplicarTodosLosDescuentosCascada(
                          item.neto,
                          item.dm,
                          item.dn,
                          item.desc_indexados
                        );

                        const netoFinalUsd = item.factor > 0 ? (netoFinal / item.factor) : netoFinal;
                        const subtotalFinal = netoFinal * item.cantidad;
                        const subtotalFinalUsd = netoFinalUsd * item.cantidad;
                        return `
                          <tr class="${idx % 2 === 0 ? 'bg-slate-50' : 'bg-white'}">
                            <td class="py-1 px-2 text-left">${item.desprod}</td>
                            <td class="py-1 px-2 text-center">${item.cantidad}</td>
                            <td class="py-1 px-2 text-center">${item.dm ?? '0.00'}</td>
                            <td class="py-1 px-2 text-center">${item.dn ?? '0.00'}</td>
                            <td class="py-1 px-2 text-center">${getIndexados(item.desc_indexados)}</td>
                            <td class="py-1 px-2 text-right">
                              <div>${functions.prices.formatCurrency(netoFinal, 'es-VE', 'VES')}</div>
                              <div class="text-[11px] text-slate-500 leading-tight">
                                ${functions.prices.formatCurrency(netoFinalUsd, 'en-US', 'USD')}
                              </div>
                            </td>

                            <td class="py-1 px-2 text-right">
                              <div>${functions.prices.formatCurrency(subtotalFinal, 'es-VE', 'VES')}</div>
                              <div class="text-[11px] text-slate-500 leading-tight">
                                ${functions.prices.formatCurrency(subtotalFinalUsd, 'en-US', 'USD')}
                              </div>
                            </td>
                          </tr>
                          </tr>
                        `;
                      }).join('')}
                    </tbody>

                    </table>
                </div>
                </div>
            </div>
        `;

        // SweetAlert2 con HTML y JS para tabs
        Swal.fire({
          focusConfirm: false,
          title: `Pedido #${response.data.id}`,
          html: htmlContent,
          showConfirmButton: false,
          customClass: {
            popup: 'swal2-popup swal2-modal swal2-show swal-wide'
          },
          didOpen: () => {
            tabContainer = document.querySelector('#modal-content');
            if (!tabContainer) return;
            const nav = tabContainer.querySelector('nav');
            const indicator = nav?.querySelector('.tab-indicator') as HTMLElement;

            const updateTabIndicator = (btn: HTMLElement) => {
            if (!nav || !indicator) return;
            indicator.style.width = `${btn.offsetWidth + 8}px`;
            indicator.style.left = `${btn.offsetLeft - nav.offsetLeft}px`;
            };

            if (tabContainer) {
              tabContainer.querySelectorAll<HTMLButtonElement>('.tab-link').forEach(btn => {
                btn.addEventListener('click', function (e) {
                  e.preventDefault();
                  tabContainer!.querySelectorAll('.tab-link').forEach(link => link.classList.remove('active-tab', 'active'));
                  this.classList.add('active-tab', 'active');
                  tabContainer!.querySelectorAll<HTMLElement>('.tab-content').forEach(content => content.classList.add('hidden'));
                  const tabId = (this as HTMLElement).dataset.tab!;
                  tabContainer!.querySelector<HTMLElement>(tabId)?.classList.remove('hidden');
                  updateTabIndicator(this as HTMLElement);
                });
              });
            }

            // Inicializa el indicador en la posición del tab activo
            const firstTab = tabContainer.querySelector<HTMLButtonElement>('.tab-link.active-tab') || tabContainer.querySelector('.tab-link');
            if (firstTab) updateTabIndicator(firstTab);

          }
        });
      });
    }
  });
}
